(function(){
	"use strict";

	angular
		.module('pwc.filters')
		.filter('highlight', highlight);

	highlight.$inject = ['$sce', 'lodash'];

	function highlight($sce, lodash) {

		return function(str, termsToHighlight) {

			termsToHighlight = lodash.trim(termsToHighlight);

			if (lodash.isEmpty(termsToHighlight) || lodash.isEmpty(str)){
				return '<span>' + str + '</span>';
			}

            //Escape characters that have meaning in regular expressions
            //via: http://stackoverflow.com/a/6969486/79677
            termsToHighlight = termsToHighlight.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

			termsToHighlight = termsToHighlight.split(" ");

			// Regex to simultaneously replace terms
			var regex = new RegExp('(' + termsToHighlight.join('|') + ')', 'ig');

			return $sce.trustAsHtml(str.replace(regex, '<span class="match">$&</span>'));
		};

	}

})();